export default __webpack_public_path__ + "static/media/rithmic_nameless.28b799d1.webp";